(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode("._overlay_5x3op_1{--swui-modal-animation-time: var(--swui-animation-time-fast);--swui-modal-overlay-bg-color: var(--swui-overlay-bg-color);--swui-modal-content-bg-color: var(--swui-white);--swui-modal-width: 960px;--swui-modal-max-width: 100%;--swui-modal-header-border-color: var(--lhds-color-ui-300);--swui-modal-shadow: var(--swui-shadow-modal);--swui-modal-footer-shadow: var(--swui-shadow-modal);position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:var(--swui-modal-overlay-bg-color);overflow:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;animation:_fadeIn_5x3op_1 var(--swui-modal-animation-time) cubic-bezier(.645,.045,.355,1) both}@media print{._overlay_5x3op_1{background-color:#fff}}._overlay_5x3op_1 ._modal_5x3op_31{max-width:100%;outline:none;pointer-events:none}@media (max-width: 768px){._overlay_5x3op_1 ._modal_5x3op_31{width:100%}}._overlay_5x3op_1 ._content_5x3op_41{position:relative;display:block;background:var(--swui-modal-content-bg-color);box-shadow:var(--swui-modal-shadow);pointer-events:all;top:calc(var(--swui-metrics-space) * 2);width:var(--swui-modal-width);max-width:var(--swui-modal-max-width)}@media (max-width: 768px){._overlay_5x3op_1 ._content_5x3op_41{top:0;width:100%;max-width:100%}}._overlay_5x3op_1 ._content_5x3op_41{animation:_appear_5x3op_1 var(--swui-animation-time-fast) cubic-bezier(.645,.045,.355,1) both}@media print{._overlay_5x3op_1 ._content_5x3op_41{box-shadow:none;top:0}}._overlay_5x3op_1 ._content_5x3op_41 :focus{outline:0}._overlay_5x3op_1 ._content_5x3op_41._isDraggable_5x3op_70 .draggable-modal-handle{cursor:move}._overlay_5x3op_1 ._content_5x3op_41._isDraggable_5x3op_70 .draggable-modal-handle .draggable-modal-cancel,._overlay_5x3op_1 ._content_5x3op_41._isDraggable_5x3op_70 .draggable-modal-handle [role=tooltip]{cursor:initial}@keyframes _fadeIn_5x3op_1{0%{background-color:var(--swui-hidden)}to{background-color:var(--swui-modal-overlay-bg-color)}}@keyframes _appear_5x3op_1{0%{opacity:0}to{opacity:1}}._footer_5x3op_101{background-color:var(--swui-modal-content-bg-color)}._stickyFooter_5x3op_105{position:-webkit-sticky;position:sticky;bottom:0;box-shadow:var(--swui-modal-footer-shadow)}@media print{._stickyFooter_5x3op_105{position:static;box-shadow:none}}._portal_17ze5_1{--drawer-width: 370px}._portal_17ze5_1 ._overlay_17ze5_4{position:fixed;top:0;right:0;bottom:0;left:0}._portal_17ze5_1 ._content_17ze5_9{box-shadow:var(--swui-shadow-modal);background:#fff;position:absolute;transition:transform var(--swui-animation-time-medium) ease-in-out}._portal_17ze5_1 ._content_17ze5_9._floating_17ze5_15{margin:var(--swui-metrics-space);border-radius:var(--swui-border-radius)}@media (max-width: 768px){._portal_17ze5_1 ._content_17ze5_9._floating_17ze5_15{margin:0;border-radius:0}}._portal_17ze5_1 ._content_17ze5_9:focus-visible{outline:unset}._portal_17ze5_1 ._content_17ze5_9._slideFromLeft_17ze5_29,._portal_17ze5_1 ._content_17ze5_9._slideFromRight_17ze5_30{transform:translate(var(--translate-x-outside-screen, 0));overflow-y:auto;top:0;bottom:0}._portal_17ze5_1 ._content_17ze5_9._slideFromLeft_17ze5_29._afterOpen_17ze5_36,._portal_17ze5_1 ._content_17ze5_9._slideFromRight_17ze5_30._afterOpen_17ze5_36{transform:translate(0)}._portal_17ze5_1 ._content_17ze5_9._slideFromLeft_17ze5_29._beforeClose_17ze5_40,._portal_17ze5_1 ._content_17ze5_9._slideFromRight_17ze5_30._beforeClose_17ze5_40{transform:translate(var(--translate-x-outside-screen))}._portal_17ze5_1 ._content_17ze5_9._slideFromTop_17ze5_45,._portal_17ze5_1 ._content_17ze5_9._slideFromBottom_17ze5_46{transform:translateY(var(--translate-y-outside-screen, 0));overflow-x:auto;left:0;right:0}._portal_17ze5_1 ._content_17ze5_9._slideFromTop_17ze5_45._afterOpen_17ze5_36,._portal_17ze5_1 ._content_17ze5_9._slideFromBottom_17ze5_46._afterOpen_17ze5_36{transform:translateY(0)}._portal_17ze5_1 ._content_17ze5_9._slideFromTop_17ze5_45._beforeClose_17ze5_40,._portal_17ze5_1 ._content_17ze5_9._slideFromBottom_17ze5_46._beforeClose_17ze5_40{transform:translateY(var(--translate-y-outside-screen))}._portal_17ze5_1 ._content_17ze5_9._slideFromLeft_17ze5_29{--translate-x-outside-screen: -100%;width:var(--drawer-width);left:0}._portal_17ze5_1 ._content_17ze5_9._slideFromRight_17ze5_30{--translate-x-outside-screen: 100%;width:var(--drawer-width);right:0}._portal_17ze5_1 ._content_17ze5_9._slideFromTop_17ze5_45{--translate-y-outside-screen: -100%;height:var(--drawer-width);top:0}._portal_17ze5_1 ._content_17ze5_9._slideFromBottom_17ze5_46{--translate-y-outside-screen: 100%;height:var(--drawer-width);bottom:0}._overlay_r9tkq_1{--swui-modal-animation-time: var(--swui-animation-time-fast);--swui-modal-overlay-bg-color: var(--swui-overlay-bg-color);--swui-modal-content-bg-color: var(--swui-white);--swui-modal-width: 960px;--swui-modal-max-width: 100%;--swui-modal-header-border-color: var(--lhds-color-ui-300);--swui-modal-shadow: var(--swui-shadow-modal);--swui-modal-footer-shadow: var(--swui-shadow-modal);position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:var(--swui-modal-overlay-bg-color);overflow:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;animation:_fadeIn_r9tkq_1 var(--swui-modal-animation-time) cubic-bezier(.645,.045,.355,1) both}@media print{._overlay_r9tkq_1{background-color:#fff}}._overlay_r9tkq_1 ._modal_r9tkq_31{max-width:100%;outline:none;pointer-events:none;padding:var(--swui-metrics-space)}._overlay_r9tkq_1 ._content_r9tkq_38{position:relative;display:block;background:var(--swui-modal-content-bg-color);box-shadow:var(--swui-modal-shadow);border-radius:var(--swui-border-radius-large);pointer-events:all;width:var(--swui-modal-width);max-width:var(--swui-modal-max-width);animation:_appear_r9tkq_1 var(--swui-animation-time-fast) cubic-bezier(.645,.045,.355,1) both}@media print{._overlay_r9tkq_1 ._content_r9tkq_38{box-shadow:none;top:0}}._overlay_r9tkq_1 ._content_r9tkq_38 :focus{outline:0}._overlay_r9tkq_1 ._content_r9tkq_38._isDraggable_r9tkq_61 .draggable-modal-handle{cursor:move}._overlay_r9tkq_1 ._content_r9tkq_38._isDraggable_r9tkq_61 .draggable-modal-handle .draggable-modal-cancel,._overlay_r9tkq_1 ._content_r9tkq_38._isDraggable_r9tkq_61 .draggable-modal-handle [role=tooltip]{cursor:initial}@keyframes _fadeIn_r9tkq_1{0%{background-color:var(--swui-hidden)}to{background-color:var(--swui-modal-overlay-bg-color)}}@keyframes _appear_r9tkq_1{0%{opacity:0}to{opacity:1}}._footer_r9tkq_92{background-color:var(--swui-modal-content-bg-color)}._stickyFooter_r9tkq_96{position:-webkit-sticky;position:sticky;bottom:0;box-shadow:var(--swui-modal-footer-shadow)}@media print{._stickyFooter_r9tkq_96{position:static;box-shadow:none}}._overlay_1rolx_1{--swui-modal-animation-time: var(--swui-animation-time-fast);--swui-modal-overlay-bg-color: var(--swui-overlay-bg-color);--swui-modal-content-bg-color: var(--swui-white);--swui-modal-width: 960px;--swui-modal-max-width: 100%;--swui-modal-header-border-color: var(--lhds-color-ui-300);--swui-modal-shadow: var(--swui-shadow-modal);--swui-modal-footer-shadow: var(--swui-shadow-modal);position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:var(--swui-modal-overlay-bg-color);overflow:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;animation:_fadeIn_1rolx_1 var(--swui-modal-animation-time) cubic-bezier(.645,.045,.355,1) both}@media print{._overlay_1rolx_1{background-color:#fff}}._overlay_1rolx_1 ._modal_1rolx_31{max-width:100%;outline:none;pointer-events:none}@media (max-width: 768px){._overlay_1rolx_1 ._modal_1rolx_31{width:100%}}._overlay_1rolx_1 ._content_1rolx_41{position:relative;display:block;background:var(--swui-modal-content-bg-color);box-shadow:var(--swui-modal-shadow);border-radius:var(--swui-border-radius-large);pointer-events:all;width:var(--swui-modal-width);max-width:var(--swui-modal-max-width)}@media (max-width: 768px){._overlay_1rolx_1 ._content_1rolx_41{border-radius:0;width:100%;max-width:100%;height:100vh}}._overlay_1rolx_1 ._content_1rolx_41{animation:_appear_1rolx_1 var(--swui-animation-time-fast) cubic-bezier(.645,.045,.355,1) both}@media print{._overlay_1rolx_1 ._content_1rolx_41{box-shadow:none;top:0}}._overlay_1rolx_1 ._content_1rolx_41 :focus{outline:0}._overlay_1rolx_1 ._content_1rolx_41._isDraggable_1rolx_71 .draggable-modal-handle{cursor:move}._overlay_1rolx_1 ._content_1rolx_41._isDraggable_1rolx_71 .draggable-modal-handle .draggable-modal-cancel,._overlay_1rolx_1 ._content_1rolx_41._isDraggable_1rolx_71 .draggable-modal-handle [role=tooltip]{cursor:initial}@keyframes _fadeIn_1rolx_1{0%{background-color:var(--swui-hidden)}to{background-color:var(--swui-modal-overlay-bg-color)}}@keyframes _appear_1rolx_1{0%{opacity:0}to{opacity:1}}._footer_1rolx_102{background-color:var(--swui-modal-content-bg-color)}._stickyFooter_1rolx_106{position:-webkit-sticky;position:sticky;bottom:0;box-shadow:var(--swui-modal-footer-shadow)}@media print{._stickyFooter_1rolx_106{position:static;box-shadow:none}}._modal_4fwgb_1{display:flex;justify-content:center;align-items:center;position:fixed;top:0;left:0;right:0;bottom:0;background-color:transparent}._overlay_4fwgb_13{position:fixed;top:0;left:0;right:0;bottom:0;background-color:var(--swui-overlay-bg-color)}._alertDialog_14t8t_1{border:0;outline:0;border-radius:var(--swui-border-radius-large);margin:auto;padding:0;overscroll-behavior:contain;opacity:0;pointer-events:none;box-shadow:#0003 0 0 10px 4px}._alertDialog_14t8t_1:not([open]){display:none}._alertDialog_14t8t_1[open]{opacity:1;pointer-events:auto;animation:_slideIn_14t8t_1 .25s forwards}._alertDialog_14t8t_1._closing_14t8t_22[open]{animation:_slideOut_14t8t_1 .25s forwards}._alertDialog_14t8t_1::backdrop{position:fixed;top:0;right:0;bottom:0;left:0;background-color:#0d0e1080;animation:_fadeIn_14t8t_1 .25s forwards}._alertDialog_14t8t_1._closing_14t8t_22::backdrop{animation:_fadeOut_14t8t_1 .25s forwards}@keyframes _fadeIn_14t8t_1{0%{opacity:0}to{opacity:1}}@keyframes _fadeOut_14t8t_1{0%{opacity:1}to{opacity:0}}@keyframes _slideIn_14t8t_1{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes _slideOut_14t8t_1{0%{transform:translateY(0);opacity:1}to{transform:translateY(-100%);opacity:0}}._drawerDialog_3e8xf_1{max-height:100%;max-width:100%;border:0;outline:0;margin:0;padding:0;overscroll-behavior:contain;box-shadow:#0003 0 0 10px 4px;position:fixed}._drawerDialog_3e8xf_1._left_3e8xf_12,._drawerDialog_3e8xf_1._right_3e8xf_13{height:100%;top:0;bottom:0}._drawerDialog_3e8xf_1._left_3e8xf_12 ._contentWrapper_3e8xf_18,._drawerDialog_3e8xf_1._right_3e8xf_13 ._contentWrapper_3e8xf_18{height:100%}@media (max-width: 768px){._drawerDialog_3e8xf_1._left_3e8xf_12,._drawerDialog_3e8xf_1._right_3e8xf_13{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}}._drawerDialog_3e8xf_1._left_3e8xf_12{left:0;right:unset}._drawerDialog_3e8xf_1._left_3e8xf_12[open]{animation:_slideInLeft_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._left_3e8xf_12._closing_3e8xf_35[open]{animation:_slideOutLeft_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._right_3e8xf_13{left:unset;right:0}._drawerDialog_3e8xf_1._right_3e8xf_13[open]{animation:_slideInRight_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._right_3e8xf_13._closing_3e8xf_35[open]{animation:_slideOutRight_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._top_3e8xf_53,._drawerDialog_3e8xf_1._bottom_3e8xf_54{width:100%;left:0;right:0}@media (max-width: 768px){._drawerDialog_3e8xf_1._top_3e8xf_53,._drawerDialog_3e8xf_1._bottom_3e8xf_54{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}}._drawerDialog_3e8xf_1._top_3e8xf_53{top:0;bottom:unset}._drawerDialog_3e8xf_1._top_3e8xf_53[open]{animation:_slideInTop_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._top_3e8xf_53._closing_3e8xf_35[open]{animation:_slideOutTop_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._bottom_3e8xf_54{top:unset;bottom:0}._drawerDialog_3e8xf_1._bottom_3e8xf_54[open]{animation:_slideInBottom_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1._bottom_3e8xf_54._closing_3e8xf_35[open]{animation:_slideOutBottom_3e8xf_1 .25s forwards}._drawerDialog_3e8xf_1[open]{opacity:1;pointer-events:auto}@keyframes _slideInLeft_3e8xf_1{0%{transform:translate(-100%);opacity:0}to{transform:translate(0);opacity:1}}@keyframes _slideOutLeft_3e8xf_1{0%{transform:translate(0);opacity:0}to{transform:translate(-100%);opacity:1}}@keyframes _slideInTop_3e8xf_1{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes _slideOutTop_3e8xf_1{0%{transform:translateY(0);opacity:0}to{transform:translateY(-100%);opacity:1}}@keyframes _slideInRight_3e8xf_1{0%{transform:translate(100%);opacity:0}to{transform:translate(0);opacity:1}}@keyframes _slideOutRight_3e8xf_1{0%{transform:translate(0);opacity:0}to{transform:translate(100%);opacity:1}}@keyframes _slideInBottom_3e8xf_1{0%{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes _slideOutBottom_3e8xf_1{0%{transform:translateY(0);opacity:0}to{transform:translateY(100%);opacity:1}}._modalDialog_6jugu_1{border:0;outline:0;margin:auto;padding:0;overscroll-behavior:contain;opacity:0;pointer-events:none;box-shadow:#0003 0 0 10px 4px}@media (min-width: 769px){._modalDialog_6jugu_1{border-radius:var(--swui-border-radius-large)}}._modalDialog_6jugu_1:not([open]){display:none}._modalDialog_6jugu_1[open]{opacity:1;pointer-events:auto;animation:_slideIn_6jugu_1 .25s forwards}._modalDialog_6jugu_1._closing_6jugu_25[open]{animation:_slideOut_6jugu_1 .25s forwards}@media (max-width: 768px){._modalDialog_6jugu_1{margin:0;width:100%;max-width:100%;height:100%;max-height:100%}}._modalDialog_6jugu_1::backdrop{position:fixed;top:0;right:0;bottom:0;left:0;background-color:#0d0e1080;animation:_fadeIn_6jugu_1 .25s forwards}._modalDialog_6jugu_1._closing_6jugu_25::backdrop{animation:_fadeOut_6jugu_1 .25s forwards}@keyframes _fadeIn_6jugu_1{0%{opacity:0}to{opacity:1}}@keyframes _fadeOut_6jugu_1{0%{opacity:1}to{opacity:0}}@keyframes _slideIn_6jugu_1{0%{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes _slideOut_6jugu_1{0%{transform:translateY(0);opacity:1}to{transform:translateY(-100%);opacity:0}}@media (max-width: 768px){._contentWrapper_6jugu_89{display:flex;height:100%}}._modalActionButtons_s27nj_1{display:flex;flex-direction:row;gap:16px;justify-content:center}@media (max-width: 768px){._modalActionButtons_s27nj_1{flex-direction:column;justify-content:stretch}}")),document.head.appendChild(o)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import x from "react-modal";
import { jsx as l, jsxs as s, Fragment as k } from "react/jsx-runtime";
import Z from "react-draggable";
import c from "classnames";
import { exhaustSwitchCase as ee, Spacing as j, Row as C, Space as T, Heading as z, Column as G, Box as N, Indent as te, Txt as le, Text as ne } from "@stenajs-webui/core";
import { Icon as V, FlatButton as ae, stenaTimes as oe, Spinner as re, CloseButton as J, CircledIcon as se } from "@stenajs-webui/elements";
import { cssColor as ce } from "@stenajs-webui/theme";
import { createContext as ie, useRef as O, useReducer as de, useState as q, useCallback as W, useMemo as _e, createElement as H, useContext as me } from "react";
const Tt = (t) => {
  x.setAppElement(t);
}, ue = "_overlay_5x3op_1", fe = "_fadeIn_5x3op_1", ge = "_modal_5x3op_31", he = "_content_5x3op_41", ye = "_appear_5x3op_1", Ce = "_isDraggable_5x3op_70", pe = "_footer_5x3op_101", ve = "_stickyFooter_5x3op_105", v = {
  overlay: ue,
  fadeIn: fe,
  modal: ge,
  content: he,
  appear: ye,
  isDraggable: Ce,
  footer: pe,
  stickyFooter: ve
}, K = "draggable-modal-handle", Q = "draggable-modal-cancel", Ne = ({
  width: t,
  maxWidth: e,
  draggable: n = !1,
  children: a,
  ...o
}) => /* @__PURE__ */ l(
  x,
  {
    overlayClassName: v.overlay,
    className: v.modal,
    ...o,
    children: /* @__PURE__ */ l(
      Z,
      {
        handle: `.${K}`,
        cancel: `.${Q}, button, [role="tooltip"]`,
        bounds: ".ReactModal__Overlay",
        disabled: !n,
        children: /* @__PURE__ */ l(
          "div",
          {
            style: {
              "--swui-modal-width": t,
              "--swui-modal-max-width": e
            },
            className: c(v.content, {
              [v.isDraggable]: n
            }),
            children: a
          }
        )
      }
    )
  }
), xe = "_portal_17ze5_1", be = "_overlay_17ze5_4", Ie = "_content_17ze5_9", Oe = "_floating_17ze5_15", we = "_slideFromLeft_17ze5_29", $e = "_slideFromRight_17ze5_30", De = "_afterOpen_17ze5_36", ke = "_beforeClose_17ze5_40", Fe = "_slideFromTop_17ze5_45", Be = "_slideFromBottom_17ze5_46", r = {
  portal: xe,
  overlay: be,
  content: Ie,
  floating: Oe,
  slideFromLeft: we,
  slideFromRight: $e,
  afterOpen: De,
  beforeClose: ke,
  slideFromTop: Fe,
  slideFromBottom: Be
}, qt = ({
  background: t,
  zIndex: e,
  children: n,
  slideFrom: a = "left",
  portalTarget: o,
  floating: g,
  ...i
}) => {
  const { height: m, width: d } = i;
  return /* @__PURE__ */ l(
    x,
    {
      closeTimeoutMS: 250,
      portalClassName: r.portal,
      overlayClassName: {
        base: r.overlay,
        afterOpen: r.afterOpen,
        beforeClose: r.beforeClose
      },
      className: {
        base: c(
          r.content,
          We(a),
          g && r.floating
        ),
        afterOpen: r.afterOpen,
        beforeClose: r.beforeClose
      },
      style: { content: { width: d, height: m, background: t }, overlay: { zIndex: e } },
      parentSelector: o ? () => o : void 0,
      ...i,
      children: n
    }
  );
}, We = (t) => {
  switch (t) {
    case "left":
      return r.slideFromLeft;
    case "right":
      return r.slideFromRight;
    case "top":
      return r.slideFromTop;
    case "bottom":
      return r.slideFromBottom;
    default:
      return ee(t, r.slideFromLeft);
  }
}, Ht = ({
  header: t,
  contentRight: e,
  onRequestClose: n,
  icon: a
}) => /* @__PURE__ */ l(
  j,
  {
    position: "sticky",
    top: 0,
    zIndex: 100,
    background: ce("--lhds-color-ui-50"),
    children: /* @__PURE__ */ s(
      C,
      {
        justifyContent: "space-between",
        alignItems: "center",
        height: "48px",
        children: [
          /* @__PURE__ */ s(C, { alignItems: "center", gap: 2, children: [
            /* @__PURE__ */ l(T, { num: 1 }),
            a && /* @__PURE__ */ l(V, { icon: a, size: 24 }),
            /* @__PURE__ */ l(z, { variant: "h4", children: t })
          ] }),
          /* @__PURE__ */ s(C, { gap: 1, children: [
            e,
            /* @__PURE__ */ l(
              ae,
              {
                leftIcon: oe,
                onClick: n,
                variant: "danger"
              }
            ),
            /* @__PURE__ */ l(T, { num: 0.5 })
          ] })
        ]
      }
    )
  }
), Re = "_overlay_r9tkq_1", Ae = "_fadeIn_r9tkq_1", Se = "_modal_r9tkq_31", Le = "_content_r9tkq_38", je = "_appear_r9tkq_1", ze = "_isDraggable_r9tkq_61", Me = "_footer_r9tkq_92", Ee = "_stickyFooter_r9tkq_96", R = {
  overlay: Re,
  fadeIn: Ae,
  modal: Se,
  content: Le,
  appear: je,
  isDraggable: ze,
  footer: Me,
  stickyFooter: Ee
}, Te = { overlay: { justifyContent: "center" } }, Pt = ({
  children: t,
  ...e
}) => /* @__PURE__ */ l(
  x,
  {
    overlayClassName: R.overlay,
    className: R.modal,
    style: Te,
    ...e,
    children: /* @__PURE__ */ l(
      "div",
      {
        className: R.content,
        style: { "--swui-modal-width": "fit-content" },
        children: t
      }
    )
  }
), qe = "_overlay_1rolx_1", He = "_fadeIn_1rolx_1", Pe = "_modal_1rolx_31", Ge = "_content_1rolx_41", Ve = "_appear_1rolx_1", Je = "_isDraggable_1rolx_71", Ke = "_footer_1rolx_102", Qe = "_stickyFooter_1rolx_106", A = {
  overlay: qe,
  fadeIn: He,
  modal: Pe,
  content: Ge,
  appear: Ve,
  isDraggable: Je,
  footer: Ke,
  stickyFooter: Qe
}, Ue = { overlay: { justifyContent: "center" } }, Gt = ({
  children: t,
  ...e
}) => /* @__PURE__ */ l(
  x,
  {
    overlayClassName: A.overlay,
    className: A.modal,
    style: Ue,
    ...e,
    children: /* @__PURE__ */ l(
      "div",
      {
        className: A.content,
        style: { "--swui-modal-width": "fit-content" },
        children: t
      }
    )
  }
), Xe = "_modal_4fwgb_1", Ye = "_overlay_4fwgb_13", P = {
  modal: Xe,
  overlay: Ye
}, Vt = ({
  headerIconLeft: t,
  headerText: e,
  shouldCloseOnOverlayClick: n = !1,
  shouldCloseOnEsc: a = !1,
  ...o
}) => /* @__PURE__ */ l(
  x,
  {
    ...o,
    isOpen: !0,
    shouldCloseOnOverlayClick: n,
    shouldCloseOnEsc: a,
    className: P.modal,
    overlayClassName: P.overlay,
    children: /* @__PURE__ */ s(G, { spacing: 2, alignItems: "center", children: [
      /* @__PURE__ */ l(
        N,
        {
          alignItems: "center",
          justifyContent: "center",
          width: "64px",
          height: "64px",
          borderRadius: "50%",
          background: "white",
          shadow: "modal",
          children: /* @__PURE__ */ l(re, { size: "small" })
        }
      ),
      (t || e) && /* @__PURE__ */ s(k, { children: [
        /* @__PURE__ */ l(j, {}),
        /* @__PURE__ */ s(C, { indent: 2, children: [
          t && /* @__PURE__ */ s(k, { children: [
            /* @__PURE__ */ l(V, { size: 14, icon: t, color: "white" }),
            /* @__PURE__ */ l(te, {})
          ] }),
          e && /* @__PURE__ */ l(z, { variant: "h4", color: "white", children: e })
        ] })
      ] })
    ] })
  }
), Ze = ({
  onRequestClose: t,
  header: e,
  headerText: n,
  closeButtonClassName: a
}) => /* @__PURE__ */ s(
  C,
  {
    spacing: 2,
    indent: 2,
    borderBottom: "1px solid var(--lhds-color-ui-300)",
    className: K,
    children: [
      /* @__PURE__ */ s(C, { flex: 1, indent: !0, alignItems: "center", children: [
        n && /* @__PURE__ */ l(le, { className: Q, size: "large", children: n }),
        e
      ] }),
      /* @__PURE__ */ l(N, { alignSelf: "flex-start", children: /* @__PURE__ */ l(
        J,
        {
          className: a,
          onClick: t
        }
      ) })
    ]
  }
), Jt = ({
  header: t,
  headerText: e,
  children: n,
  spacing: a,
  indent: o,
  draggable: g = !1,
  onRequestClose: i,
  closeButtonClassName: m,
  footer: d,
  disableStickyFooter: p = !1,
  ...b
}) => /* @__PURE__ */ s(
  Ne,
  {
    ...b,
    onRequestClose: i,
    draggable: g,
    children: [
      /* @__PURE__ */ l(
        Ze,
        {
          onRequestClose: i,
          header: t,
          headerText: e,
          closeButtonClassName: m
        }
      ),
      /* @__PURE__ */ l(N, { spacing: typeof a == "number" ? a : 1, indent: typeof o == "number" ? o : 1, children: n }),
      d && /* @__PURE__ */ l(
        N,
        {
          className: c(v.footer, {
            [v.stickyFooter]: !p
          }),
          children: d
        }
      )
    ]
  }
), Kt = ({ children: t }) => /* @__PURE__ */ l(G, { indent: 2, spacing: 2, children: t }), U = ie(
  void 0
);
function M(t, e) {
  const n = O(null), a = e.ref ?? n, [o, g] = de((_) => _ + 1, 0), i = O(), m = O(), d = O(), p = O(), [b, w] = q(!1), [F, I] = q(!1), B = t, Y = W(
    (_) => {
      var u, f;
      return i.current = new Promise(
        (h, y) => {
          m.current = h, p.current = y;
        }
      ), I(!1), w(!0), g(), d.current = _, e.modal ? (u = a.current) == null || u.showModal() : (f = a.current) == null || f.show(), i.current;
    },
    [a, e.modal]
  ), E = W(
    (_) => {
      var u;
      I(!0), (u = a.current) == null || u.addEventListener(
        "animationend",
        () => {
          var f, h, y;
          I(!1), w(!1), (f = a.current) == null || f.close(), (h = m.current) == null || h.call(m, _), d.current = void 0, (y = e.onResolve) == null || y.call(e);
        },
        { once: !0 }
      );
    },
    [a, e]
  ), $ = W(
    (_) => {
      var u;
      I(!0), (u = a.current) == null || u.addEventListener(
        "animationend",
        () => {
          var f, h, y;
          I(!1), w(!1), (f = a.current) == null || f.close(), (h = p.current) == null || h.call(p, _), (y = e.onReject) == null || y.call(e), d.current = void 0;
        },
        { once: !0 }
      );
    },
    [a, e]
  );
  return [_e(
    () => /* @__PURE__ */ l(U.Provider, { value: { resolve: E, reject: $ }, children: /* @__PURE__ */ l(
      "dialog",
      {
        onClick: e.disableCloseOnClickOutside ? void 0 : () => $(),
        ref: a,
        className: c(e.className, F && e.closingClassName),
        style: e.dialogStyle,
        children: e.disableCloseOnClickOutside ? /* @__PURE__ */ l(k, { children: b && /* @__PURE__ */ H(B, { ...d.current, key: o }) }) : /* @__PURE__ */ l(
          "div",
          {
            style: e.contentWrapperStyle,
            className: e.contentWrapperClassName,
            onClick: e.disableCloseOnClickOutside ? void 0 : (_) => _.stopPropagation(),
            children: b && /* @__PURE__ */ H(B, { ...d.current, key: o })
          }
        )
      }
    ) }),
    [
      E,
      $,
      e.disableCloseOnClickOutside,
      e.className,
      e.closingClassName,
      e.dialogStyle,
      e.contentWrapperStyle,
      e.contentWrapperClassName,
      a,
      F,
      b,
      B,
      o
    ]
  ), { show: Y, reject: $ }];
}
const Qt = () => {
  const t = me(U);
  if (t == null)
    throw new Error("useDialogPromise is being used outside of dialog.");
  return t;
}, et = "_alertDialog_14t8t_1", tt = "_slideIn_14t8t_1", lt = "_closing_14t8t_22", nt = "_slideOut_14t8t_1", at = "_fadeIn_14t8t_1", ot = "_fadeOut_14t8t_1", S = {
  alertDialog: et,
  slideIn: tt,
  closing: lt,
  slideOut: nt,
  fadeIn: at,
  fadeOut: ot
};
function Ut(t, e) {
  return M(t, {
    ...e,
    modal: !0,
    closingClassName: c(e == null ? void 0 : e.closingClassName, S.closing),
    contentWrapperClassName: c(
      e == null ? void 0 : e.contentWrapperClassName,
      S.contentWrapper
    ),
    className: c(e == null ? void 0 : e.className, S.alertDialog)
  });
}
const rt = "_drawerDialog_3e8xf_1", st = "_left_3e8xf_12", ct = "_right_3e8xf_13", it = "_contentWrapper_3e8xf_18", dt = "_slideInLeft_3e8xf_1", _t = "_closing_3e8xf_35", mt = "_slideOutLeft_3e8xf_1", ut = "_slideInRight_3e8xf_1", ft = "_slideOutRight_3e8xf_1", gt = "_top_3e8xf_53", ht = "_bottom_3e8xf_54", yt = "_slideInTop_3e8xf_1", Ct = "_slideOutTop_3e8xf_1", pt = "_slideInBottom_3e8xf_1", vt = "_slideOutBottom_3e8xf_1", D = {
  drawerDialog: rt,
  left: st,
  right: ct,
  contentWrapper: it,
  slideInLeft: dt,
  closing: _t,
  slideOutLeft: mt,
  slideInRight: ut,
  slideOutRight: ft,
  top: gt,
  bottom: ht,
  slideInTop: yt,
  slideOutTop: Ct,
  slideInBottom: pt,
  slideOutBottom: vt
};
function Xt(t, e = "left", n) {
  return M(t, {
    ...n,
    disableCloseOnClickOutside: !0,
    modal: !1,
    closingClassName: c(n == null ? void 0 : n.closingClassName, D.closing),
    contentWrapperClassName: c(
      n == null ? void 0 : n.contentWrapperClassName,
      D.contentWrapper
    ),
    className: c(n == null ? void 0 : n.className, D.drawerDialog, D[e])
  });
}
const Nt = "_modalDialog_6jugu_1", xt = "_slideIn_6jugu_1", bt = "_closing_6jugu_25", It = "_slideOut_6jugu_1", Ot = "_fadeIn_6jugu_1", wt = "_fadeOut_6jugu_1", $t = "_contentWrapper_6jugu_89", L = {
  modalDialog: Nt,
  slideIn: xt,
  closing: bt,
  slideOut: It,
  fadeIn: Ot,
  fadeOut: wt,
  contentWrapper: $t
};
function Yt(t, e) {
  return M(t, {
    ...e,
    modal: !0,
    closingClassName: c(e == null ? void 0 : e.closingClassName, L.closing),
    contentWrapperClassName: c(
      e == null ? void 0 : e.contentWrapperClassName,
      L.contentWrapper
    ),
    className: c(e == null ? void 0 : e.className, L.modalDialog)
  });
}
const X = ({ children: t }) => /* @__PURE__ */ l(z, { variant: "h3", as: "h2", children: t }), Dt = "_modalActionButtons_s27nj_1", kt = {
  modalActionButtons: Dt
}, Ft = ({
  buttons: t
}) => /* @__PURE__ */ l("div", { className: kt.modalActionButtons, children: t }), Bt = ({ gap: t = 2, ...e }) => /* @__PURE__ */ l(N, { indent: 4, spacing: 4, gap: t, ...e }), Zt = ({
  icon: t,
  buttons: e,
  heading: n,
  text: a,
  children: o,
  maxWidth: g,
  minWidth: i
}) => /* @__PURE__ */ s(
  Bt,
  {
    flexDirection: "column",
    alignItems: "center",
    maxWidth: g,
    minWidth: i,
    children: [
      t && /* @__PURE__ */ l(se, { icon: t, size: "large" }),
      /* @__PURE__ */ l(X, { children: n }),
      a && /* @__PURE__ */ l(ne, { textAlign: "center", children: a }),
      o,
      e && /* @__PURE__ */ l(k, { children: /* @__PURE__ */ s(N, { width: "100%", children: [
        /* @__PURE__ */ l(j, {}),
        /* @__PURE__ */ l(Ft, { buttons: e })
      ] }) })
    ]
  }
), el = ({
  heading: t,
  onClickClose: e
}) => /* @__PURE__ */ s(C, { justifyContent: "space-between", children: [
  t && /* @__PURE__ */ l(X, { children: t }),
  /* @__PURE__ */ l(J, { onClick: e })
] });
export {
  Pt as Alert,
  Ne as BaseWindow,
  Q as DRAGGABLE_CANCEL_CLASSNAME,
  K as DRAGGABLE_HANDLE_CLASSNAME,
  qt as Drawer,
  Ht as DrawerHeader,
  Zt as InfoAlert,
  Vt as LoadingModal,
  Gt as Modal,
  Ft as ModalActionButtons,
  Bt as ModalBody,
  el as ModalHeader,
  X as ModalHeading,
  Jt as Window,
  Kt as WindowFooter,
  Ze as WindowHeader,
  Tt as setupDeclarativeModals,
  Ut as useAlertDialog,
  M as useDialog,
  Qt as useDialogPromise,
  Xt as useDrawerDialog,
  Yt as useModalDialog
};
//# sourceMappingURL=index.es.js.map
